module.exports = __webpack_public_path__ + "img/DerTurm.c284eec4.jpg";